"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  REQUIRED: 'Required.',
  ENTER_VALID_NUMBER: 'Enter valid number.',
  FIELD_MUST_BE_CHECKED: 'Field must be checked.',
  INVALID_DATE: 'The date cannot be before today.'
};
exports.default = _default;